export const func = {
    storyblok2Css: (blok, addClasses) => {
        var str = "";
        if (addClasses && addClasses.length > 0)
            str += addClasses;
        if (blok.margin_top && blok.margin_top.length > 0)
            str += " mt-" + blok.margin_top;
        return str;
     }
 }